<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">
          <template v-if="isEditModeUpdate">アイコンメニュー編集</template>
          <template v-else>アイコンメニュー登録</template>
        </h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <!-- アイコンメニュー管理 -->
      <div class="form-group">
        <span>
          <label class="required-mark">※</label>
          設定名
          <input
            type="text"
            id="txtSettingName"
            class="text1 form-control"
            maxlength="255"
            v-model="iconMenuKanriData.settingName"
            ref="txtSettingName"
          />
        </span>
        <span v-if="!isEditModeUpdate">
          <label class="required-mark">※</label>
          反映日
          <input
            type="date"
            id="reflectionDate"
            class="form-control"
            :max="AppConstants.MAX_DATE_VALUE"
            v-model="reflectionDate"
          />
        </span>
        <fieldset>
          <legend>設定対象</legend>
          <input
            type="radio"
            id="rdoDefault"
            name="targetSetting"
            class="form-check-input"
            value="0"
            v-model="iconMenuKanriData.settingTargetKbn"
            v-bind:disabled="isDefaultId"
            v-on:change="onChangeSettingTarget"
          />
          <label class="label1">デフォルト</label>
          <input
            type="radio"
            id="rdoAgsegment"
            name="targetSetting"
            class="form-check-input"
            value="1"
            v-model="iconMenuKanriData.settingTargetKbn"
            v-on:change="onChangeSettingTarget"
          />
          <label class="label2">エージェントセグメント</label>
          <select
            id="agSegmentList"
            class="select1 form-control"
            v-model="iconMenuKanriData.settingTargetCode"
            v-bind:disabled="!isIconMenuTargetSegment"
          >
            <option></option>
            <option
              v-for="item in agSegmentList"
              :key="item.agSegmentCode"
              :value="item.agSegmentCode"
            >
              <div v-if="isIconMenuTargetSegment">
                {{ item.agSegmentCode }}:{{ item.agSegmentName }}
              </div>
            </option>
          </select>
          <input
            type="radio"
            id="rdoKobetuAg"
            name="targetSetting"
            class="form-check-input"
            value="2"
            v-model="iconMenuKanriData.settingTargetKbn"
            v-on:change="onChangeSettingTarget"
          />
          <label class="label2">個別エージェント</label>
          <label class="label2">AGコード</label>
          <input
            v-if="isIconMenuTargetvCode"
            type="text"
            id="txtTitle"
            class="text2 form-control"
            maxlength="8"
            v-model="iconMenuKanriData.settingTargetCode"
            v-bind:disabled="!isIconMenuTargetvCode"
          />
          <input
            v-else
            type="text"
            id="txtTitle"
            class="text2 form-control"
            maxlength="8"
            v-bind:disabled="!isIconMenuTargetvCode"
          />
        </fieldset>
      </div>
      <!-- アイコンメニュー管理(現在設定) -->
      <div class="">
        <!-- 一覧ファイルアップロード用項目 -->
        <input
          type="file"
          :accept="iconMenuImgFileExtensions.join(',')"
          @change="handleContentsFileSelected"
          ref="iconMenuImgFileInput"
          style="display: none"
        />
        <div class="tableLabel" v-if="isEditModeUpdate">
          <label class="label1">現在の設定</label>
          <label class="label3">反映日</label>
          <label class="label3">{{ reflectionDate }}</label>
          <label>管理ID：</label>
          <label>{{ iconMenuKanriData.iconMenuKanriId }}</label>
        </div>
        <table class="table table-bordered" id="nowSetting">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">削除</th>
              <th class="col_catgory">カテゴリ</th>
              <th class="col_iconMenuName">アイコンメニュー名</th>
              <th class="col_dafaultImg">通常時画像</th>
              <th class="col_hoverImg">マウスホバー時画像</th>
              <th class="col_url">リンクURL</th>
              <th class="col_link">リンク確認</th>
              <th class="col_dispTarget">表示順</th>
              <th class="col_separateTab">別タブ表示</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in iconMenuKanriData.nowSettingList"
              :key="item.categoryId"
              style="height: 120px"
            >
              <td class="col_selection" data-name="mSelection">
                <input
                  id="mSelection"
                  type="checkbox"
                  class="form-check-input"
                  v-model="item.selection"
                />
              </td>
              <td>
                <select
                  id="table"
                  class="form-control"
                  v-model="item.categoryId"
                  @change="
                    changeUrl(
                      item.categoryId,
                      IconMenuManegmentConstants.ICONMENU_SETTING_NOW,
                      index
                    )
                  "
                >
                  <option></option>
                  <option
                    v-for="item in categoryList"
                    :key="item.categoryId"
                    :value="item.categoryId"
                  >
                    {{ item.categoryName }}
                  </option>
                </select>
              </td>
              <td class="unchanged">
                <input
                  style="
                    border: powderblue solid 1px;
                    text-align: left;
                    padding-left: 8px;
                  "
                  class="form-control unchanged"
                  id="dispName"
                  type="text"
                  maxlength="15"
                  v-model="item.iconMenuName"
                />
              </td>
              <td>
                <div class="flex-container">
                  <span class="img-group">
                    <img
                      v-if="item.imgPathNomal && !item.previewNomalUrl"
                      class="col_imgCell"
                      :src="
                        '/WITH_AG_PORTAL/images/' +
                        item.imgPathNomal +
                        '?v=' +
                        new Date().getTime()
                      "
                    />
                    <img
                      v-if="item.previewNomalUrl"
                      :src="item.previewNomalUrl"
                      alt="1"
                      class="col_imgCell"
                    />
                  </span>
                  <span style="text-align: left">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="
                        onContentsFileUpload(
                          IconMenuManegmentConstants.ICONMENU_NOW_NOMAL,
                          index
                        )
                      "
                    >
                      参照
                    </button>
                    <button
                      v-if="isEditModeUpdate"
                      type="button"
                      name="mBtnUpdate"
                      class="btn btn-primary btn-sm"
                      v-bind:disabled="
                        beforeIconMenuData.nowSettingList[index] == null
                      "
                      @click.prevent="
                        onDownload(
                          IconMenuManegmentConstants.ICONMENU_NOW_NOMAL,
                          item.imgPathNomal,
                          index
                        )
                      "
                    >
                      DL
                    </button>
                  </span>
                </div>
              </td>
              <td>
                <div class="flex-container">
                  <span class="img-group">
                    <img
                      v-if="item.imgPathHover && !item.previewHoverUrl"
                      class="col_imgCell"
                      :src="
                        '/WITH_AG_PORTAL/images/' +
                        item.imgPathHover +
                        '?v=' +
                        new Date().getTime()
                      "
                    />
                    <img
                      v-if="item.previewHoverUrl"
                      :src="item.previewHoverUrl"
                      alt="1"
                      class="col_imgCell"
                    />
                  </span>
                  <span style="text-align: left">
                    <button
                      type="button"
                      name="mBtnUpdate"
                      class="btn btn-primary btn-sm"
                      @click="
                        onContentsFileUpload(
                          IconMenuManegmentConstants.ICONMENU_NOW_HOVER,
                          index
                        )
                      "
                    >
                      参照
                    </button>
                    <button
                      v-if="isEditModeUpdate"
                      type="button"
                      name="mBtnUpdate"
                      class="btn btn-primary btn-sm"
                      v-bind:disabled="
                        beforeIconMenuData.nowSettingList[index] == null
                      "
                      @click.prevent="
                        onDownload(
                          IconMenuManegmentConstants.ICONMENU_NOW_HOVER,
                          item.imgPathHover,
                          index
                        )
                      "
                    >
                      DL
                    </button>
                  </span>
                </div>
              </td>
              <td class="unchanged" v-if="item.categoryId == sonotaCategoryId">
                <input
                  style="
                    border: powderblue solid 1px;
                    text-align: left;
                    padding-left: 8px;
                  "
                  class="form-control unchanged"
                  id="url"
                  type="text"
                  maxlength="255"
                  v-model="item.url"
                />
              </td>
              <td data-wrap v-else style="text-align: left">
                <label>
                  {{ item.url }}
                </label>
              </td>
              <td>
                <button
                  type="button"
                  name="mBtnUpdate"
                  class="btn btn-primary btn-sm"
                  v-bind:disabled="item.categoryId != sonotaCategoryId"
                  @click="
                    onLinkCheck(
                      IconMenuManegmentConstants.ICONMENU_SETTING_NOW,
                      item.url,
                      index
                    )
                  "
                >
                  確認
                </button>
              </td>
              <td class="unchanged">
                <NumericInput
                  v-model="item.dispNo"
                  style="
                    border: powderblue solid 1px;
                    text-align: center;
                    padding-left: 8px;
                  "
                  class="form-control unchanged"
                  @input="
                    numberLimit(
                      IconMenuManegmentConstants.ICONMENU_SETTING_NOW,
                      index
                    )
                  "
                />
              </td>
              <td>
                <input
                  id="mSelection1"
                  type="checkbox"
                  class="form-check-input"
                  name="nowStting"
                  :value="0"
                  v-model="item.isSeparateTab"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="form-footer">
          <div class="form-group" style="text-align: right">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="rowAdd(IconMenuManegmentConstants.ICONMENU_SETTING_NOW)"
            >
              行追加
            </button>
          </div>
          <div
            class="form-group"
            style="text-align: center"
            v-if="isEditModeUpdate"
          >
            <button
              type="button"
              name="btnBack"
              class="btn addbtn btn-primary"
              @click="onCopy"
            >
              下にコピーする▼
            </button>
          </div>
        </div>

        <!-- アイコンメニュー管理(反映予定) -->
        <div class="" v-if="isEditModeUpdate">
          <hr />
          <div class="tableLabel" v-if="isEditModeUpdate">
            <label class="label1">反映予定の設定</label>
            <label class="label2">反映日</label>
            <input
              type="date"
              id="txtDispDtFrom"
              class="inputDate form-control"
              v-model="scheduledDate"
              :max="AppConstants.MAX_DATE_VALUE"
            />
            <label>管理ID：</label>
            <label>{{ iconMenuKanriData.iconMenuKanriId }}</label>
          </div>
          <table class="table table-bordered" v-if="isDataFetched">
            <thead class="thead-light">
              <tr>
                <th class="col_selection">削除</th>
                <th class="col_catgory">カテゴリ</th>
                <th class="col_iconMenuName">アイコンメニュー名</th>
                <th class="col_dafaultImg">通常時画像</th>
                <th class="col_hoverImg">マウスホバー時画像</th>
                <th class="col_url">リンクURL</th>
                <th class="col_link">リンク確認</th>
                <th class="col_dispTarget">表示順</th>
                <th class="col_separateTab">別タブ表示</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in iconMenuKanriData.scheduledSettingList"
                :key="item.categoryId"
                style="height: 120px"
              >
                <td class="col_selection" data-name="mSelection">
                  <input
                    id="mSelection"
                    type="checkbox"
                    class="form-check-input"
                    v-model="item.selection"
                  />
                </td>
                <td>
                  <select
                    id="table"
                    class="form-control"
                    v-model="item.categoryId"
                    @change="
                      changeUrl(
                        item.categoryId,
                        IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED,
                        index
                      )
                    "
                  >
                    <option></option>
                    <option
                      v-for="item in categoryList"
                      :key="item.categoryId"
                      :value="item.categoryId"
                    >
                      {{ item.categoryName }}
                    </option>
                  </select>
                </td>
                <td class="unchanged">
                  <input
                    style="
                      border: powderblue solid 1px;
                      text-align: left;
                      padding-left: 8px;
                    "
                    class="form-control unchanged"
                    id="dispName"
                    type="text"
                    maxlength="15"
                    v-model="item.iconMenuName"
                  />
                </td>
                <td>
                  <div class="flex-container">
                    <span class="img-group">
                      <img
                        v-if="item.imgPathNomal && !item.previewNomalUrl"
                        class="col_imgCell"
                        :src="
                          '/WITH_AG_PORTAL/images/' +
                          item.imgPathNomal +
                          '?v=' +
                          new Date().getTime()
                        "
                      />
                      <img
                        v-if="item.previewNomalUrl"
                        :src="item.previewNomalUrl"
                        alt="1"
                        class="col_imgCell"
                      />
                    </span>
                    <span style="text-align: left">
                      <button
                        type="button"
                        name="mBtnUpdate"
                        class="btn btn-primary btn-sm"
                        @click="
                          onContentsFileUpload(
                            IconMenuManegmentConstants.ICONMENU_SCHEDULED_NOMAL,
                            index
                          )
                        "
                      >
                        参照
                      </button>
                      <button
                        v-if="isEditModeUpdate"
                        type="button"
                        name="mBtnUpdate"
                        class="btn btn-primary btn-sm"
                        v-bind:disabled="
                          beforeIconMenuData.scheduledSettingList[index] == null
                        "
                        @click.prevent="
                          onDownload(
                            IconMenuManegmentConstants.ICONMENU_SCHEDULED_NOMAL,
                            item.imgPathNomal,
                            index
                          )
                        "
                      >
                        DL
                      </button>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="flex-container">
                    <span class="img-group">
                      <img
                        v-if="item.imgPathHover && !item.previewHoverUrl"
                        class="col_imgCell"
                        :src="
                          '/WITH_AG_PORTAL/images/' +
                          item.imgPathHover +
                          '?v=' +
                          new Date().getTime()
                        "
                      />
                      <img
                        v-if="item.previewHoverUrl"
                        :src="item.previewHoverUrl"
                        alt="1"
                        class="col_imgCell"
                      />
                    </span>
                    <span style="text-align: left">
                      <button
                        type="button"
                        name="mBtnUpdate"
                        class="btn btn-primary btn-sm"
                        @click="
                          onContentsFileUpload(
                            IconMenuManegmentConstants.ICONMENU_SCHEDULED_HOVER,
                            index
                          )
                        "
                      >
                        参照
                      </button>
                      <button
                        v-if="isEditModeUpdate"
                        type="button"
                        name="mBtnUpdate"
                        class="btn btn-primary btn-sm"
                        v-bind:disabled="
                          beforeIconMenuData.scheduledSettingList[index] == null
                        "
                        @click.prevent="
                          onDownload(
                            IconMenuManegmentConstants.ICONMENU_SCHEDULED_HOVER,
                            item.imgPathHover,
                            index
                          )
                        "
                      >
                        DL
                      </button>
                    </span>
                  </div>
                </td>
                <td
                  class="unchanged"
                  v-if="item.categoryId == sonotaCategoryId"
                >
                  <textarea
                    style="
                      border: powderblue solid 1px;
                      height: 110px;
                      max-width: 100%;
                    "
                    id="url"
                    class="form-control unchanged"
                    maxlength="255"
                    v-model="item.url"
                  ></textarea>
                </td>
                <td data-wrap v-else style="text-align: left">
                  <label>
                    {{ item.url }}
                  </label>
                </td>
                <td>
                  <button
                    type="button"
                    name="mBtnUpdate"
                    class="btn btn-primary btn-sm"
                    v-bind:disabled="item.categoryId != sonotaCategoryId"
                    @click="
                      onLinkCheck(
                        IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED,
                        item.url,
                        index
                      )
                    "
                  >
                    確認
                  </button>
                </td>
                <td class="unchanged">
                  <NumericInput
                    v-model="item.dispNo"
                    style="
                      border: powderblue solid 1px;
                      text-align: center;
                      padding-left: 8px;
                    "
                    class="form-control unchanged"
                    @input="
                      numberLimit(
                        IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED,
                        index
                      )
                    "
                  />
                </td>
                <td>
                  <input
                    id="mSelection2"
                    type="checkbox"
                    class="form-check-input"
                    name="scheduledSetting"
                    :value="1"
                    v-model="item.isSeparateTab"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="form-group" style="text-align: right">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="
                rowAdd(IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED)
              "
            >
              行追加
            </button>
          </div>
          <label
            >※リンクの確認およびプレビューは、入力後、確定をしないと反映されません。</label
          >
        </div>
        <div class="form-inline flex-container">
          <div class="form-group">
            <button
              type="button"
              name="btnDelete"
              class="btn btn-footer btn-primary"
              @click="onDelete"
            >
              行削除
            </button>
          </div>

          <div class="form-group">
            <button
              v-if="isEditModeUpdate"
              type="button"
              name="btnDelete"
              class="btn previewbtn btn-primary"
              @click="
                onPreview(IconMenuManegmentConstants.ICONMENU_SETTING_NOW)
              "
            >
              現在の設定をプレビュー
            </button>
            <button
              v-if="isEditModeUpdate"
              type="button"
              name="btnDelete"
              class="btn previewbtn btn-primary"
              @click="
                onPreview(IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED)
              "
            >
              反映予定の設定をプレビュー
            </button>
          </div>

          <div class="form-group">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="goBack"
            >
              戻る
            </button>
            <button
              v-if="!isEditModeUpdate"
              type="button"
              name="btnClear"
              class="btn btn-footer btn-primary"
              @click="onClear"
            >
              クリア
            </button>
            <button
              type="button"
              name="btnAdd"
              class="btn btn-footer btn-primary"
              @click="onFixed"
            >
              確定
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import * as tus from "tus-js-client"; // * as tus を使ってインポート
import { defineComponent, onMounted, ref, computed, PropType } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  scrollToTop,
  isTokenAlive,
  commonHandleAxiosError,
  hasNoGaiji,
  sanitizeInput,
  checkFileName,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter, useRoute } from "vue-router";
import { format } from "date-fns";
import { goBackToPreviousUrl } from "@/router";
import NumericInput from "../controls/NumericInput.vue";
import apiDownloadClient from "@/util/apiClientDownload";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface NowList {
  selection: boolean;
  reflectionDate: string;
  kanriId: string;
  categoryId: string;
  iconMenuName: string;
  imgPathNomal: string;
  previewNomalUrl: string;
  imgPathHover: string;
  previewHoverUrl: string;
  url: string;
  dispNo: number;
  isSeparateTab: boolean;
}

interface scheduledList {
  selection: boolean;
  reflectionDate: string;
  kanriId: string;
  categoryId: string;
  iconMenuName: string;
  imgPathNomal: string;
  previewNomalUrl: string;
  imgPathHover: string;
  previewHoverUrl: string;
  url: string;
  dispNo: number;
  isSeparateTab: boolean;
}

interface IconMenuKanriData {
  iconMenuKanriId: string;
  settingName: string;
  settingTargetKbn: string;
  settingTargetName: string;
  settingTargetCode: string;
  nowSettingList: NowList[];
  scheduledSettingList: scheduledList[];
  uploadIconFileList: ContentsFile[];
}

interface Category {
  categoryId: string;
  categoryName: string;
  categoryUrl: string;
}

interface AgSegment {
  agSegmentCode: string;
  agSegmentName: string;
}

interface InitialDisplayData {
  categoryList: Category[];
  agSegmentList: AgSegment[];
  defaultKanriId: string;
  reflectionDate: string;
  sonotaCategoryId: string;
  maxFileSize: string;
}

// 添付ファイルのinterface
interface ContentsFile {
  rowNo: number;
  trigger: string;
  fileName: string;
  file: File | null;
  fileUrl: string | null;
  isUpload: boolean;
}

class IconMenuManegmentConstants {
  // 設定
  static readonly ICONMENU_SETTING_NOW = "01"; // 現在設定
  static readonly ICONMENU_SETTING_SCHEDULED = "02"; // 反映予定

  // イベント発火元
  static readonly ICONMENU_NOW_NOMAL = "1"; // 現在設定通常時画像
  static readonly ICONMENU_NOW_HOVER = "2"; // 現在設定ホバー時画像
  static readonly ICONMENU_SCHEDULED_NOMAL = "3"; // 反映予定ホバー時画像
  static readonly ICONMENU_SCHEDULED_HOVER = "4"; // 反映予定通常時画像
}

export default defineComponent({
  name: "IconMenuManegmentComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    NumericInput,
    LoadingOverlay,
  },
  props: {
    iconMenuKanriId: {
      type: String as PropType<string>,
    },
    editMode: {
      type: String as PropType<string>,
    },
  },
  setup() {
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const router = useRouter();
    const route = useRoute();
    const paramIconMenuKanriId = computed(
      () => route.query.iconMenuKanriId as string
    ); // パラメータ．アイコンメニュー管理ID
    const paramEditMode = computed(() => route.query.editMode as string); // パラメータ．編集モード
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID
    const categoryList = ref<Category[]>([]); // カテゴリリスト
    const agSegmentList = ref<AgSegment[]>([]); // AGセグメントリスト
    const isDefaultId = ref(false); // デフォルト設定済みかどうか
    const defaultKanriId = ref(""); // デフォルトアイコンメニュー管理ID
    const reflectionDate = ref(""); // 反映日
    const scheduledDate = ref(""); // 反映予定日
    const sonotaCategoryId = ref(""); //その他のカテゴリID
    const { logoutUser } = useUserStore();
    let maxFileSize = 0; // ファイルアップロードの最大サイズ
    const iconMenuImgFileExtensions = [".jpg", ".png"]; // アイコンメニュー画像ファイルの拡張子
    const uploadTarget = ref("");
    const uploadIndex = ref(0);
    const uploadProgress = ref<number | null>(null);
    const isLoading = ref(false);

    const iconMenuKanriData = ref<IconMenuKanriData>({
      iconMenuKanriId: "",
      settingName: "",
      settingTargetKbn: "",
      settingTargetName: "",
      settingTargetCode: "",
      nowSettingList: [],
      scheduledSettingList: [],
      uploadIconFileList: [],
    });

    const beforeIconMenuData = ref<IconMenuKanriData>({
      iconMenuKanriId: "",
      settingName: "",
      settingTargetKbn: "",
      settingTargetName: "",
      settingTargetCode: "",
      nowSettingList: [],
      scheduledSettingList: [],
      uploadIconFileList: [],
    });

    const initialDisplayData = ref<InitialDisplayData>({
      categoryList: [],
      agSegmentList: [],
      defaultKanriId: "",
      reflectionDate: "",
      sonotaCategoryId: "",
      maxFileSize: "",
    });

    // routerパラメータ退避用
    let iconMenuKanriId = ref(""); // アイコンメニュー管理ID
    let editMode = ref(""); // 編集モード

    const txtSettingName = ref<HTMLInputElement | null>(null);
    const iconMenuImgFileInput = ref<HTMLInputElement | null>(null);

    // 初期処理
    onMounted(async () => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
      }

      // パラメーターから取得
      iconMenuKanriId.value = paramIconMenuKanriId.value;
      editMode.value = paramEditMode.value;

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // 初期表示データ取得
        const response = await apiAuthClient.post(
          "/api/IconMenuManegment/getInitialDisplayData",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
          }
        );

        initialDisplayData.value = response.data.iconMenuInitialDisplayData;

        // カテゴリリストコンボボックス設定
        categoryList.value = initialDisplayData.value.categoryList;

        // エージェントセグメントコンボボックス設定
        agSegmentList.value = initialDisplayData.value.agSegmentList;

        defaultKanriId.value = initialDisplayData.value.defaultKanriId;
        sonotaCategoryId.value = initialDisplayData.value.sonotaCategoryId;

        // 反映日設定
        reflectionDate.value = formatDate(
          initialDisplayData.value.reflectionDate
        );
        scheduledDate.value = formatDate(
          initialDisplayData.value.reflectionDate
        );

        maxFileSize = parseInt(initialDisplayData.value.maxFileSize || "0", 10);

        // 編集モードが更新の場合
        if (isEditModeUpdate.value) {
          await getIconMenuData();

          if (defaultKanriId.value !== iconMenuKanriId.value) {
            // デフォルト設定ではないなら
            isDefaultId.value = true;
          }
        } else {
          if (defaultKanriId.value != "") {
            // デフォルトの管理IDが設定されているなら
            isDefaultId.value = true;
            iconMenuKanriData.value.settingTargetKbn = "1";
          } else {
            iconMenuKanriData.value.settingTargetKbn = "0";
          }
        }

        setTimeout(function () {
          // フォーカス設定
          if (txtSettingName.value) {
            txtSettingName.value.focus();
          }
        }, 1);

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        isInitError.value = true;
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**
     * アイコンメニュー管理データ取得
     */
    const getIconMenuData = async (): Promise<boolean> => {
      try {
        const response = await apiAuthClient.post(
          "/api/IconMenuManegment/GetIconMenuData",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            iconMenuKanriId: iconMenuKanriId.value,
          }
        );

        // レスポンスを保持
        iconMenuKanriData.value = response.data.iconMenuKanriData;

        // データがゼロ件の場合は一覧画面へ遷移する
        if (!iconMenuKanriData.value.iconMenuKanriId) {
          router.push("/iconmenu-kanri-list");
          return false;
        }

        iconMenuKanriData.value.uploadIconFileList = [];

        // 反映日設定
        reflectionDate.value =
          iconMenuKanriData.value.nowSettingList[0].reflectionDate;

        // 反映予定日設定
        if (
          Object.keys(iconMenuKanriData.value.scheduledSettingList).length > 0
        ) {
          scheduledDate.value = formatDate(
            iconMenuKanriData.value.scheduledSettingList[0].reflectionDate
          );
        }

        // 変更前のリストを退避
        beforeIconMenuData.value = JSON.parse(
          JSON.stringify(iconMenuKanriData.value)
        );

        setTimeout(function () {
          // フォーカス設定
          if (txtSettingName.value) {
            txtSettingName.value.focus();
          }
        }, 1);

        scrollToTop();

        return true;
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        return false;
      }
    };

    /**
     * 登録ボタン押下
     */
    const onFixed = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";

      // 入力チェック
      if (!validateInput()) {
        scrollToTop();
        return;
      }

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(
          messages.CNF_0001,
          "データ",
          isEditModeUpdate.value ? "更新" : "登録"
        )
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // 画像ファイルをアップロード
        const result = await executeContentsFiles(
          iconMenuKanriData.value.uploadIconFileList
        );

        // ファイルアップロードに失敗している場合
        if (!result) {
          scrollToTop();
          errorMessage.value = formatMessage(
            messages.ERR_SYS003,
            "ファイルアップロード"
          );
          return;
        }

        if (isEditModeUpdate.value) {
          // 更新処理
          await executeUpdate();
        } else {
          // 登録処理
          await executeCreate();
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * ファイルアップロード実行
     * @param contentsFileList
     */
    async function executeContentsFiles(contentsFileList: ContentsFile[]) {
      let result = true;

      for (const contentsFile of contentsFileList) {
        if (contentsFile.isUpload) {
          try {
            await uploadContentsFile(contentsFile);
          } catch (error) {
            result = false;
            break;
          }
        }
      }

      return result;
    }

    /**
     * ファイルアップロード処理
     * @param item
     */
    const uploadContentsFile = (contentsFile: ContentsFile): Promise<void> => {
      return new Promise((resolve, reject) => {
        if (!contentsFile.file) {
          reject("No file selected");
          return;
        }

        // ローカルストレージからトークンを取得
        const token = localStorage.getItem(AppConstants.TOKEN_SESSION_NAME);
        if (!token) {
          reject("No token found. Please log in.");
          return;
        }

        const upload = new tus.Upload(contentsFile.file, {
          // ファイルアップロードのエンドポイント
          endpoint: process.env.VUE_APP_FILE_UPLOAD_ENDPOINT,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          metadata: {
            filename: contentsFile.file.name,
            filetype: contentsFile.file.type,
            agcode: agCode.value,
            userid: userId.value,
          },
          onError: (error) => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.error("Upload failed:", error);
            }
            reject(error);
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            uploadProgress.value = Math.floor(
              (bytesUploaded / bytesTotal) * 100
            );
          },
          onSuccess: () => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.log("Upload finished:", upload.url);
            }
            // ファイルURLを保存
            contentsFile.fileUrl = upload.url;
            resolve();
          },
        });

        upload.start();
      });
    };

    /**
     * 登録処理
     */
    const executeCreate = async () => {
      try {
        // 表示順で並び替え
        iconMenuKanriData.value.nowSettingList.sort(
          (a, b) => a.dispNo - b.dispNo
        );

        // アイコンメニュー管理データ登録APIを実行
        const response = await apiAuthClient.post(
          "/api/IconMenuManegment/regIconMenu",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            settingName: sanitizeInput(iconMenuKanriData.value.settingName),
            settingTargetKbn: iconMenuKanriData.value.settingTargetKbn,
            settingTargetName: iconMenuKanriData.value.settingTargetName,
            settingTargetCode: iconMenuKanriData.value.settingTargetCode,
            nowSettingList: iconMenuKanriData.value.nowSettingList.map(
              (iconMenuData) => ({
                selection: iconMenuData.selection,
                reflectionDate: iconMenuData.reflectionDate,
                kanriId: iconMenuData.kanriId,
                categoryId: iconMenuData.categoryId,
                iconMenuName: sanitizeInput(iconMenuData.iconMenuName),
                imgPathNomal: iconMenuData.imgPathNomal,
                imgPathHover: iconMenuData.imgPathHover,
                url: sanitizeInput(iconMenuData.url),
                dispNo: iconMenuData.dispNo,
                isSeparateTab: iconMenuData.isSeparateTab,
              })
            ),
            uploadIconFileList: iconMenuKanriData.value.uploadIconFileList,
          }
        );
        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "登録"));

        // 確認ダイアログ表示
        const isConfirm = window.confirm(formatMessage(messages.CNF_0005));
        if (isConfirm) {
          // OKの場合

          // 新規登録可能な状態にする
          resetNew();
        } else {
          // キャンセルの場合

          // 編集モードを設定
          editMode.value = AppConstants.CONTENTS_EDIT_MODE_UPDATE;
          // コンテンツIDを設定
          iconMenuKanriId.value = response.data.iconMenuKanriId;

          // アイコンメニューデータ再取得
          await getIconMenuData();

          setTimeout(function () {
            // フォーカス設定
            if (txtSettingName.value) {
              txtSettingName.value.focus();
            }
          }, 1);
        }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 新規登録可能な状態にする
     */
    const resetNew = () => {
      // 新規登録モードを設定
      editMode.value = AppConstants.CONTENTS_EDIT_MODE_NEW;
      // 画面入力内容クリア
      iconMenuKanriData.value = getIconMenuDataDef();

      //反映日初期値設定
      reflectionDate.value = formatDate(
        initialDisplayData.value.reflectionDate
      );

      // スクロールを上部に移動
      scrollToTop();

      setTimeout(function () {
        // フォーカス設定
        if (txtSettingName.value) {
          txtSettingName.value.focus();
        }
      }, 1);
    };

    /**
     * 更新処理
     */
    const executeUpdate = async () => {
      try {
        // 反映予定日セット
        Object.values(iconMenuKanriData.value.scheduledSettingList).forEach(
          (item) => {
            if (item && typeof item.reflectionDate === "string") {
              item.reflectionDate = scheduledDate.value.toString();
            }
          }
        );

        // 表示順で並び替え
        iconMenuKanriData.value.nowSettingList.sort(
          (a, b) => a.dispNo - b.dispNo
        );
        iconMenuKanriData.value.scheduledSettingList.sort(
          (a, b) => a.dispNo - b.dispNo
        );

        // アイコンメニュー管理更新APIを実行
        await apiAuthClient.post("/api/IconMenuManegment/updateIconMenu", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          agCode: agCode.value,
          userId: userId.value,
          iconMenuKanriId: iconMenuKanriId.value,
          settingName: sanitizeInput(iconMenuKanriData.value.settingName),
          settingTargetKbn: iconMenuKanriData.value.settingTargetKbn,
          settingTargetName: iconMenuKanriData.value.settingTargetName,
          settingTargetCode: iconMenuKanriData.value.settingTargetCode,
          nowSettingList: iconMenuKanriData.value.nowSettingList.map(
            (iconMenuData) => ({
              selection: iconMenuData.selection,
              reflectionDate: iconMenuData.reflectionDate,
              kanriId: iconMenuData.kanriId,
              categoryId: iconMenuData.categoryId,
              iconMenuName: sanitizeInput(iconMenuData.iconMenuName),
              imgPathNomal: iconMenuData.imgPathNomal,
              imgPathHover: iconMenuData.imgPathHover,
              url: sanitizeInput(iconMenuData.url),
              dispNo: iconMenuData.dispNo,
              isSeparateTab: iconMenuData.isSeparateTab,
            })
          ),
          scheduledSettingList:
            iconMenuKanriData.value.scheduledSettingList.map(
              (scheduledData) => ({
                selection: scheduledData.selection,
                reflectionDate: scheduledData.reflectionDate,
                kanriId: scheduledData.kanriId,
                categoryId: scheduledData.categoryId,
                iconMenuName: sanitizeInput(scheduledData.iconMenuName),
                imgPathNomal: scheduledData.imgPathNomal,
                imgPathHover: scheduledData.imgPathHover,
                url: sanitizeInput(scheduledData.url),
                dispNo: scheduledData.dispNo,
                isSeparateTab: scheduledData.isSeparateTab,
              })
            ),
          uploadIconFileList: iconMenuKanriData.value.uploadIconFileList,
        });

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "更新"));

        // コンテンツデータ再取得
        await getIconMenuData();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * ファイルサイズチェック
     */
    const isFileSize = (file: File | null): boolean => {
      return (file?.size ?? 0) <= maxFileSize;
    };

    /**
     * ファイル拡張子チェック
     * @param file ファイル
     * @param extensions 拡張子
     */
    const isFileExtensions = (
      file: File | null,
      ...extensions: string[]
    ): boolean => {
      return extensions.some((extension) =>
        file?.name.toLowerCase().endsWith(extension)
      );
    };

    /* 添付ファイルアップロードボタン押下時
     * @param index
     */
    const onContentsFileUpload = (trigger: string, index: number) => {
      // イベントの発火元
      uploadTarget.value = trigger;
      uploadIndex.value = index;
      if (iconMenuImgFileInput.value) {
        iconMenuImgFileInput.value.click();
      }
    };

    /**
     * 添付ファイル選択時
     * @param event
     */
    const handleContentsFileSelected = (event: Event) => {
      contentsFileSelected(event, uploadTarget.value, uploadIndex.value);
    };

    /**
     * 添付ファイル選択時
     * @param event
     * @param trigger
     */
    const contentsFileSelected = (
      event: Event,
      trigger: string,
      index: number
    ) => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      errorMessage.value = "";

      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];

      try {
        if (file) {
          const contentsFile = {
            rowNo: index,
            trigger: trigger,
            fileName: file.name,
            file: file,
            fileUrl: null,
            isUpload: true,
          };

          // ファイルサイズチェック
          if (!isFileSize(contentsFile.file)) {
            errorMessage.value = formatMessage(
              messages.ERR_0024,
              maxFileSize / (1024 * 1024)
            );
            scrollToTop();
            return;
          }

          let messageId = "";
          let arg = "";

          if (
            !isFileExtensions(contentsFile.file, ...iconMenuImgFileExtensions)
          ) {
            // 拡張子チェック
            messageId = messages.ERR_0027;
            arg = "画像ファイル";
          } else if (!checkFileName(file.name.toLowerCase())) {
            // ファイル名チェック
            messageId = messages.ERR_0025;
            arg = "画像ファイル名";
          }

          // エラーがある場合
          if (messageId) {
            errorMessage.value = formatMessage(messageId, arg);
            scrollToTop();
            return;
          }

          // 発火元によって処理を分岐
          switch (trigger) {
            case IconMenuManegmentConstants.ICONMENU_NOW_NOMAL:
              // 画像のURLを取得しファイル名を設定する
              getPreviewUrl(file, trigger, index);
              iconMenuKanriData.value.nowSettingList[index].imgPathNomal =
                contentsFile.fileName;
              break;
            case IconMenuManegmentConstants.ICONMENU_NOW_HOVER:
              getPreviewUrl(file, trigger, index);
              iconMenuKanriData.value.nowSettingList[index].imgPathHover =
                contentsFile.fileName;
              break;
            case IconMenuManegmentConstants.ICONMENU_SCHEDULED_NOMAL:
              getPreviewUrl(file, trigger, index);
              iconMenuKanriData.value.scheduledSettingList[index].imgPathNomal =
                contentsFile.fileName;
              break;
            case IconMenuManegmentConstants.ICONMENU_SCHEDULED_HOVER:
              getPreviewUrl(file, trigger, index);
              iconMenuKanriData.value.scheduledSettingList[index].imgPathHover =
                contentsFile.fileName;
              break;
          }

          // アップロードファイル名変更フラグ
          let changeFlag = false;

          if (iconMenuKanriData.value.uploadIconFileList.length === 0) {
            iconMenuKanriData.value.uploadIconFileList.push(contentsFile);
          } else {
            // アップロードファイルリストへ追加
            iconMenuKanriData.value.uploadIconFileList.forEach(
              (iconMenuData) => {
                if (
                  iconMenuData.rowNo === contentsFile.rowNo &&
                  iconMenuData.trigger === contentsFile.trigger
                ) {
                  // 行番号と発火元が一致する場合変更する
                  iconMenuData.fileName = "1";
                  iconMenuData.file = contentsFile.file;
                  changeFlag = true;
                }
              }
            );
            if (!changeFlag) {
              iconMenuKanriData.value.uploadIconFileList.push(contentsFile);
            }
          }
        }
      } finally {
        // ファイルを未選択状態にする
        fileInput.value = "";
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * プレビューURL取得
     */
    const getPreviewUrl = (file: File, trigger: string, index: number) => {
      // 画像プレビューURL発行
      const reader = new FileReader();

      // 発火元によって処理を分岐
      switch (trigger) {
        case IconMenuManegmentConstants.ICONMENU_NOW_NOMAL:
          // URL発行
          reader.onload = (e) => {
            iconMenuKanriData.value.nowSettingList[index].previewNomalUrl = e
              .target?.result as string;
          };
          reader.readAsDataURL(file);
          break;
        case IconMenuManegmentConstants.ICONMENU_NOW_HOVER:
          reader.onload = (e) => {
            iconMenuKanriData.value.nowSettingList[index].previewHoverUrl = e
              .target?.result as string;
          };
          reader.readAsDataURL(file);
          break;
        case IconMenuManegmentConstants.ICONMENU_SCHEDULED_NOMAL:
          reader.onload = (e) => {
            iconMenuKanriData.value.scheduledSettingList[
              index
            ].previewNomalUrl = e.target?.result as string;
          };
          reader.readAsDataURL(file);
          break;
        case IconMenuManegmentConstants.ICONMENU_SCHEDULED_HOVER:
          reader.onload = (e) => {
            iconMenuKanriData.value.scheduledSettingList[
              index
            ].previewHoverUrl = e.target?.result as string;
          };
          reader.readAsDataURL(file);
          break;
      }
    };

    const onDownload = (trigger: string, fileName: string, index: number) => {
      // 変更前ファイル名
      let beforefileName = " ";

      // 発火元によって処理を分岐
      switch (trigger) {
        case IconMenuManegmentConstants.ICONMENU_NOW_NOMAL:
          // 発火元に該当する変更前のファイル名を設定
          beforefileName =
            beforeIconMenuData.value.nowSettingList[index].imgPathNomal;
          break;
        case IconMenuManegmentConstants.ICONMENU_NOW_HOVER:
          beforefileName =
            beforeIconMenuData.value.nowSettingList[index].imgPathHover;
          break;
        case IconMenuManegmentConstants.ICONMENU_SCHEDULED_NOMAL:
          beforefileName =
            beforeIconMenuData.value.scheduledSettingList[index].imgPathNomal;
          break;
        case IconMenuManegmentConstants.ICONMENU_SCHEDULED_HOVER:
          beforefileName =
            beforeIconMenuData.value.scheduledSettingList[index].imgPathHover;
          break;
      }

      if (fileName == beforefileName) {
        // 変更前のURL同じならダウンロード実行
        downloadFile(fileName);
      } else {
        errorMessage.value = formatMessage(
          messages.ERR_0037,
          "ファイル",
          "DLボタン"
        );
        scrollToTop();
      }
    };

    /**
     * ファイルダウンロード
     */
    const downloadFile = async (downloadFileName: string) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post(
          "/api/download/iconMenu",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            fileName: downloadFileName,
            screenName: "アイコンメニュー管理",
          }
        );

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);
        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /** リンク確認ボタン押下時 */
    const onLinkCheck = (listype: string, url: string, index: number) => {
      if (listype == IconMenuManegmentConstants.ICONMENU_SETTING_NOW) {
        if (
          beforeIconMenuData.value.nowSettingList[index] &&
          iconMenuKanriData.value.nowSettingList[index].url ==
            beforeIconMenuData.value.nowSettingList[index].url
        ) {
          window.open(url);
        } else {
          errorMessage.value = messages.ERR_0033;
          scrollToTop();
        }
      } else {
        if (
          beforeIconMenuData.value.scheduledSettingList[index] &&
          iconMenuKanriData.value.scheduledSettingList[index].url ==
            beforeIconMenuData.value.scheduledSettingList[index].url
        ) {
          window.open(url);
        } else {
          errorMessage.value = messages.ERR_0033;
          scrollToTop();
        }
      }
    };

    /** 下にコピーするボタン押下時 */
    const onCopy = () => {
      if (iconMenuKanriData.value.scheduledSettingList.length > 0) {
        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "現在の設定データ", "下にコピー")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }
      }

      // 現在設定を反映予定データにコピー
      var copyList = JSON.parse(
        JSON.stringify(iconMenuKanriData.value.nowSettingList)
      );

      iconMenuKanriData.value.scheduledSettingList = copyList;
    };

    /** 行追加ボタン押下時 */
    const rowAdd = (listType: string) => {
      if (listType == IconMenuManegmentConstants.ICONMENU_SETTING_NOW) {
        iconMenuKanriData.value.nowSettingList.push({
          selection: false,
          reflectionDate: reflectionDate.value,
          kanriId: "",
          categoryId: "",
          iconMenuName: "",
          imgPathNomal: "",
          previewNomalUrl: "",
          imgPathHover: "",
          previewHoverUrl: "",
          url: "",
          dispNo: 0,
          isSeparateTab: false,
        });
      } else {
        iconMenuKanriData.value.scheduledSettingList.push({
          selection: false,
          reflectionDate: scheduledDate.value,
          kanriId: "",
          categoryId: "",
          iconMenuName: "",
          imgPathNomal: "",
          previewNomalUrl: "",
          imgPathHover: "",
          previewHoverUrl: "",
          url: "",
          dispNo: 0,
          isSeparateTab: false,
        });
      }
    };

    /** 削除ボタン押下時 */
    const onDelete = () => {
      iconMenuKanriData.value.nowSettingList =
        iconMenuKanriData.value.nowSettingList.filter(
          (item) => item.selection == false
        );
      iconMenuKanriData.value.scheduledSettingList =
        iconMenuKanriData.value.scheduledSettingList.filter(
          (item) => item.selection == false
        );
    };

    /**
     * プレビュー表示
     */
    const onPreview = (detailKbn: string) => {
      console.log(iconMenuKanriData.value.iconMenuKanriId);
      const routeData = router.resolve({
        name: "PreviewIconMenu",
        params: {
          iconMenuKanriId: iconMenuKanriData.value.iconMenuKanriId,
          detailKbn: detailKbn,
        },
      });

      window.open(routeData.href, "_blank_");
    };

    /**
     * クリアボタン押下時
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 初期化
        iconMenuKanriData.value = getIconMenuDataDef();

        // 反映日初期値設定
        reflectionDate.value = formatDate(
          initialDisplayData.value.reflectionDate
        );

        outputDebugLogs("defaultKanriId.value:" + defaultKanriId.value);

        // 表示対象初期値設定
        if (defaultKanriId.value != "") {
          isDefaultId.value = true;
          iconMenuKanriData.value.settingTargetKbn = "1";
        } else {
          iconMenuKanriData.value.settingTargetKbn = "0";
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /** 戻るボタン押下時 */
    const goBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // もとの画面に戻る処理
      goBackToPreviousUrl();
    };

    /**
     * 表示対象ラジオ変更時
     */
    const onChangeSettingTarget = () => {
      iconMenuKanriData.value.settingTargetCode = "";
      iconMenuKanriData.value.settingTargetName = "";
    };

    /**
     * カテゴリリストＵＲＬ連動
     */
    const changeUrl = (categoryId: string, listType: string, index: number) => {
      const resultUrl = categoryList.value.find(
        (category) => category.categoryId == categoryId
      );

      if (resultUrl !== undefined) {
        if (listType == IconMenuManegmentConstants.ICONMENU_SETTING_NOW) {
          iconMenuKanriData.value.nowSettingList[index].url =
            resultUrl.categoryUrl;
        } else {
          iconMenuKanriData.value.scheduledSettingList[index].url =
            resultUrl.categoryUrl;
        }
      }
    };

    /**
     * 編集モードUPDATE判定
     */
    const isEditModeUpdate = computed(() => {
      return editMode.value == AppConstants.CONTENTS_EDIT_MODE_UPDATE;
    });

    /**
     * AG_SEGMENT判定
     */
    const isIconMenuTargetSegment = computed(() => {
      return iconMenuKanriData.value.settingTargetKbn == "1";
    });

    /**
     * AG_SEGMENT_CODE判定
     */
    const isIconMenuTargetvCode = computed(() => {
      return iconMenuKanriData.value.settingTargetKbn == "2";
    });

    /**
     * サーバー日付をフォーマットします。
     */
    const formatDate = (strDate: string): string => {
      if (strDate) {
        return format(strDate, "yyyy-MM-dd");
      }
      return "";
    };

    /**
     * コンテンツデータの初期値を返却します。
     */
    const getIconMenuDataDef = (): IconMenuKanriData => {
      return {
        iconMenuKanriId: "",
        settingName: "",
        settingTargetKbn: "",
        settingTargetName: "",
        settingTargetCode: "",
        nowSettingList: [],
        scheduledSettingList: [],
        uploadIconFileList: [],
      };
    };

    // 表示順桁数制限
    const numberLimit = (listType: string, index: number) => {
      const maxlength = 3;
      if (listType == IconMenuManegmentConstants.ICONMENU_SETTING_NOW) {
        if (
          iconMenuKanriData.value.nowSettingList[index].dispNo &&
          iconMenuKanriData.value.nowSettingList[index].dispNo.toString()
            .length > maxlength
        ) {
          iconMenuKanriData.value.nowSettingList[index].dispNo = parseInt(
            iconMenuKanriData.value.nowSettingList[index].dispNo
              .toString()
              .slice(0, maxlength)
          );
        }
      } else {
        if (
          iconMenuKanriData.value.scheduledSettingList[index].dispNo &&
          iconMenuKanriData.value.scheduledSettingList[index].dispNo.toString()
            .length > maxlength
        ) {
          iconMenuKanriData.value.scheduledSettingList[index].dispNo = parseInt(
            iconMenuKanriData.value.scheduledSettingList[index].dispNo
              .toString()
              .slice(0, maxlength)
          );
        }
      }
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 設定名
      // 必須チェック、使用不可文字チェック
      const sanitizedSettingName = sanitizeInput(
        iconMenuKanriData.value.settingName
      );
      if (!sanitizedSettingName) {
        messageList.value.push(formatMessage(messages.ERR_0001, "設定名"));
      } else if (!hasNoGaiji(sanitizedSettingName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "設定名"));
      }

      // 反映日（現在設定）
      // 必須チェック
      if (!reflectionDate.value) {
        messageList.value.push(formatMessage(messages.ERR_0001, "反映日"));
      }

      // 反映日 (反映予定)
      // 反映予定が入力済みで、編集モードの場合
      if (
        iconMenuKanriData.value.scheduledSettingList.length > 0 &&
        isEditModeUpdate.value
      ) {
        // 反映日 (反映予定)
        // 必須チェック
        if (!scheduledDate.value) {
          messageList.value.push(
            formatMessage(messages.ERR_0001, "［反映予定の設定］反映日")
          );
        }

        // 反映日 (反映予定)
        // 反映日と現在設定の反映日大小チェック
        if (new Date(reflectionDate.value) > new Date(scheduledDate.value)) {
          messageList.value.push(formatMessage(messages.ERR_0034));
        }
      }

      if (isIconMenuTargetSegment.value) {
        // エージェントセグメント

        // 必須チェック
        if (!iconMenuKanriData.value.settingTargetCode) {
          messageList.value.push(
            formatMessage(messages.ERR_0003, "エージェントセグメント")
          );
        }
      } else if (isIconMenuTargetvCode.value) {
        // AGコード

        const sanitizedAgCode = sanitizeInput(
          iconMenuKanriData.value.settingTargetCode
        );
        // 必須チェック、使用不可文字チェック
        if (!sanitizedAgCode) {
          messageList.value.push(formatMessage(messages.ERR_0002, "AGコード"));
        } else if (!hasNoGaiji(sanitizedAgCode)) {
          messageList.value.push(formatMessage(messages.ERR_0026, "AGコード"));
        }
      }

      // 現在設定明細チェック
      if (iconMenuKanriData.value.nowSettingList.length == 0) {
        messageList.value.push(formatMessage(messages.ERR_0004, "現在の設定"));
      }

      // 現在設定チェック
      for (var data1 in iconMenuKanriData.value.nowSettingList) {
        // カテゴリ
        // 必須チェック
        if (!iconMenuKanriData.value.nowSettingList[data1].categoryId) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value ? "［現在の設定］カテゴリ" : "カテゴリ"
            )
          );
        }

        // 表示名
        // 必須チェック、使用不可文字チェック
        const sanitizedIconMenuName = sanitizeInput(
          iconMenuKanriData.value.nowSettingList[data1].iconMenuName
        );
        if (!sanitizedIconMenuName) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value
                ? "［現在の設定］アイコンメニュー名"
                : "アイコンメニュー名"
            )
          );
        } else if (!hasNoGaiji(sanitizedIconMenuName)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value
                ? "［現在の設定］アイコンメニュー名"
                : "アイコンメニュー名"
            )
          );
        }

        // 通常時のアイコン画像
        // 必須チェック
        if (!iconMenuKanriData.value.nowSettingList[data1].imgPathNomal) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value
                ? "［現在の設定］通常時のアイコン画像"
                : "通常時のアイコン画像"
            )
          );
        }

        // マウスホバー時のアイコン画像
        // 必須チェック
        if (!iconMenuKanriData.value.nowSettingList[data1].imgPathHover) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value
                ? "［現在の設定］マウスホバー時のアイコン画像"
                : "マウスホバー時のアイコン画像"
            )
          );
        }

        // URL
        // 必須チェック、使用不可文字チェック
        const sanitizedUrl = sanitizeInput(
          iconMenuKanriData.value.nowSettingList[data1].url
        );
        if (!sanitizedUrl) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［現在の設定］リンクURL" : "リンクURL"
            )
          );
        } else if (!hasNoGaiji(sanitizedUrl)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value ? "［現在の設定］リンクURL" : "リンクURL"
            )
          );
        }

        // 表示順
        // 必須チェック
        if (!iconMenuKanriData.value.nowSettingList[data1].dispNo) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［現在の設定］表示順" : "表示順"
            )
          );
        }
      }

      // 反映予定チェック
      for (var data2 in iconMenuKanriData.value.scheduledSettingList) {
        // カテゴリ
        // 必須チェック
        if (!iconMenuKanriData.value.scheduledSettingList[data2].categoryId) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value ? "［反映予定の設定］カテゴリ" : "カテゴリ"
            )
          );
        }

        // 表示名
        // 必須チェック、使用不可文字チェック
        const sanitizedIconMenuName = sanitizeInput(
          iconMenuKanriData.value.scheduledSettingList[data2].iconMenuName
        );
        if (!sanitizedIconMenuName) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value
                ? "［反映予定の設定］アイコンメニュー名"
                : "アイコンメニュー名"
            )
          );
        } else if (!hasNoGaiji(sanitizedIconMenuName)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value
                ? "［反映予定の設定］アイコンメニュー名"
                : "アイコンメニュー名"
            )
          );
        }

        // 通常時のアイコン画像
        // 必須チェック
        if (!iconMenuKanriData.value.scheduledSettingList[data2].imgPathNomal) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value
                ? "［反映予定の設定］通常時のアイコン画像"
                : "通常時のアイコン画像"
            )
          );
        }

        // マウスホバー時のアイコン画像
        // 必須チェック
        if (!iconMenuKanriData.value.scheduledSettingList[data2].imgPathHover) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value
                ? "［反映予定の設定］マウスホバー時のアイコン画像"
                : "マウスホバー時のアイコン画像"
            )
          );
        }

        // URL
        // 必須チェック、使用不可文字チェック
        const sanitizedUrl = sanitizeInput(
          iconMenuKanriData.value.scheduledSettingList[data2].url
        );
        if (!sanitizedUrl) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value
                ? "［反映予定の設定］リンクURL"
                : "リンクURL"
            )
          );
        } else if (!hasNoGaiji(sanitizedUrl)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value
                ? "［反映予定の設定］リンクURL"
                : "リンクURL"
            )
          );
        }

        // 表示順
        // 必須チェック
        if (!iconMenuKanriData.value.scheduledSettingList[data2].dispNo) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［反映予定の設定］表示順" : "表示順"
            )
          );
        }
      }

      // 表示順(現在設定)
      // 重複チェック
      const setNo1 = new Set();
      iconMenuKanriData.value.nowSettingList.forEach((item) => {
        if (setNo1.has(item.dispNo.toString())) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0017,
              isEditModeUpdate.value ? "［現在の設定］表示順" : "表示順"
            )
          );
        }
        setNo1.add(item.dispNo.toString());
      });

      // 表示順(反映予定)
      // 重複チェック
      const setNo2 = new Set();
      iconMenuKanriData.value.scheduledSettingList.forEach((item) => {
        if (setNo2.has(item.dispNo.toString())) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0017,
              isEditModeUpdate.value ? "［反映予定の設定］表示順" : "表示順"
            )
          );
        }
        setNo2.add(item.dispNo.toString());
      });

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    return {
      isInitError,
      isDataFetched,
      isEditModeUpdate,
      errorMessage,
      isKaunetAdmin,
      AppConstants,
      onChangeSettingTarget,
      iconMenuKanriData,
      beforeIconMenuData,
      reflectionDate,
      scheduledDate,
      isDefaultId,
      isIconMenuTargetSegment,
      isIconMenuTargetvCode,
      agSegmentList,
      changeUrl,
      IconMenuManegmentConstants,
      categoryList,
      sonotaCategoryId,
      onLinkCheck,
      numberLimit,
      rowAdd,
      goBack,
      onDelete,
      onClear,
      onPreview,
      onFixed,
      onCopy,
      txtSettingName,
      handleContentsFileSelected,
      iconMenuImgFileExtensions,
      onContentsFileUpload,
      iconMenuImgFileInput,
      executeContentsFiles,
      onDownload,
      isLoading,
    };
  },
});
</script>

<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}
.col_selection {
  width: 4%;
}
.col_catgory {
  width: 15%;
}
.col_iconMenuName {
  width: 14%;
}
.col_dafaultImg {
  width: 15%;
}
.col_hoverImg {
  width: 15%;
}
.col_url {
  width: 14%;
}
.col_link {
  width: 8%;
}
.col_dispTarget {
  width: 6%;
}
.col_separateTab {
  width: 8%;
}
fieldset {
  border: 2px solid #ccc;
  padding: 10px;
  margin: 10px 0;
}
legend {
  font-weight: bold;
  padding: 0 10px;
  float: initial;
  width: initial;
  margin-bottom: initial;
  font-size: initial;
  line-height: initial;
}
.form-control-title {
  text-align: center;
  background-color: lightgrey;
  border-radius: 0.25rem;
}
.changed {
  background-color: #bed0f3;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.addbtn {
  margin: 0.5rem 0.55rem;
  border-radius: 1rem;
  width: 140px;
  align-items: center;
}
.previewbtn {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  align-items: center;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  text-align: center;
  vertical-align: middle;
}
.label1 {
  margin-right: 60px;
}
.label2 {
  margin-right: 20px;
}
.label3 {
  margin-right: 10px;
}
.select1 {
  width: 280px;
  margin-right: 20px;
}
.text1 {
  margin-right: 60px;
}
.text2 {
  width: 240px;
}
.inputDate {
  margin-right: 20px;
}
.tableLabel {
  margin: 10px;
}
.unchanged {
  background-color: #fffdbf;
}
.form-check-input#rdoDefault {
  margin-bottom: -0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
  vertical-align: inherit;
}
.form-check-input#rdoAgsegment {
  margin-bottom: -0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
  vertical-align: inherit;
}
.form-check-input#rdoKobetuAg {
  margin-bottom: -0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
  vertical-align: inherit;
}
.form-control {
  display: inline-block;
  vertical-align: middle;
}
.form-control#txtDispDtFrom {
  width: initial;
}
.form-control#reflectionDate {
  width: initial;
}
.form-control#txtSettingName {
  width: initial;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
.form-control#table {
  padding: initial;
  padding-left: 5px;
  border-color: lightskyblue;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* 折り返し表示用スタイル */
td[data-wrap] {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 0; /* 必要に応じて幅を設定 */
}
textarea {
  resize: none;
  overflow: hidden;
}
</style>
